/**
 * Shared scroll height for primary full-page DataTables.
 *
 * 63vh matches the existing YouTube Scorecard / Music Asset Audit tables.
 * The 25rem floor keeps a usable body on shorter laptop viewports where 63vh
 * would otherwise collapse under KPI/filter chrome.
 *
 * Intentionally a CSS length (not flex fill): PageContainer does not provide a
 * remaining-viewport height chain, so PrimeReact scrollHeight="flex" cannot
 * resolve against a parent height.
 */
export const FULL_PAGE_TABLE_SCROLL_HEIGHT = "max(25rem, 63vh)";
